"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayTripItineraryItemLocationType = void 0;
var DayTripItineraryItemLocationType;
(function (DayTripItineraryItemLocationType) {
    /**
     * Start and end points of the trip (pickup/dropoff locations).
     * Always the first and last items in the itinerary.
     * Not tourist destinations - just logistical points.
     */
    DayTripItineraryItemLocationType["edgeLocation"] = "edgeLocation";
    /**
     * Actual tourist destinations where passengers spend time.
     * These have durations and are the main stops of the trip.
     */
    DayTripItineraryItemLocationType["location"] = "location";
    /**
     * Quick photo stops with brief durations.
     * Tourist activity but not a full destination visit.
     */
    DayTripItineraryItemLocationType["photoLocation"] = "photoLocation";
    /**
     * Places the vehicle passes through without stopping.
     * Used for route visualization but passengers don't get out.
     */
    DayTripItineraryItemLocationType["passByLocation"] = "passByLocation";
})(DayTripItineraryItemLocationType || (exports.DayTripItineraryItemLocationType = DayTripItineraryItemLocationType = {}));
//# sourceMappingURL=day-trip-itinerary-item-location-type.enum.js.map